import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { IoMdRefresh } from "react-icons/io";
import { Img } from "react-image";
import { useIntl } from "react-intl";
import Skeleton from "react-loading-skeleton";
import QRCode from "react-qr-code";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SweetAlert2 from "react-sweetalert2";
import { CopyToClipboard, toAbsoluteUrl } from "../../../utils/CommonHelper";
import { fetchIPAddress } from "../../auth/api/loginapi";
import { useAuth } from "../../auth/components/AuthInit";
import * as actions from "../redux/HomeAction";
import Marquee from "./marquee";

const Image = ({ className, imageUrl, name, onClick }) => {
  return (
    <div onClick={onClick}>
      <Img
        src={imageUrl}
        unloader={<img className={className} alt={name} src={imageUrl} />}
        className={className}
        alt={name}
        decode={false}
        loading="lazy"
        loader={
          <div style={{ position: "relative", width: "100%", height: "100%" }}>
            <div
              style={{
                position: "absolute",
                color: "white",
                fontSize: "2vh",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                textAlign: "center",
                width: "100%",
              }}
            >
              {name}
            </div>
            <img
              src={toAbsoluteUrl("/image/defaultimage.png")}
              alt={name}
              className="skeleton"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </div>
        }
      />
    </div>
  );
};

const GameItem = ({ game, handlePlayGame, wrapperClass = "", style }) => {
  const intl = useIntl();
  const [isShowPlay, setIsShowPlay] = useState(false);

  return (
    <div className={`mb-2 ${wrapperClass}`} style={style ?? { width: "31%" }}>
      <div
        className="rounded company-active position-relative"
        onMouseEnter={() => setIsShowPlay(true)}
        onMouseLeave={() => setIsShowPlay(false)}
      >
        <div>
          <img src={game.imageurl} alt={game.gamename} className="w-100 mb-2" />
          <div
            className="text-center text-truncate px-2 text-font1"
            style={{ color: "white" }}
          >
            {game.gamename}
          </div>
        </div>
        {isShowPlay && (
          <div
            className="position-absolute w-100 top-0 bottom-0 rounded d-flex flex-column align-items-center justify-content-center"
            style={{ background: "rgba(0,0,0,0.8)" }}
          >
            {/* <div className="text-center text-truncate px-2" style={{ color: 'white' }}>{game.gamename}</div> */}
            <button
              type="button"
              className="btn btn-info fw-bold text-font1"
              onClick={() =>
                handlePlayGame(game.gamecode, game.gametype, game.companycode)
              }
            >
              {intl.formatMessage({ id: "play" })}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export const Home = ({}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [category, setCategory] = useState("");
  const height = `${
    (window.innerWidth > 1300 ? 1300 : window.innerWidth) / 1.8
  }px`;
  const [categoryIndex, setCategoryIndex] = useState(0);
  const { auth } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [companyOffset, setCompanyOffset] = useState(
    location.state ? parseInt(location.state.companyOffset) : 0,
  );
  const homeState = useSelector(({ home }) => home, shallowEqual);
  const [isLoading, setIsLoading] = useState(false);
  const [swalProps, setSwalProps] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [selectedInbox, setSelectedInbox] = useState(null);

  const handleInboxClick = (inbox) => {
    setSelectedInbox(inbox);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handlePlayGame = (gameCode, gameType, companyCode) => {
    let playType;
    if (gameType === "slot") {
      playType = 1;
    } else if (gameType === "live") {
      playType = 2;
    } else if (gameType === "fishing") {
      playType = 3;
    } else if (gameType === "sport") {
      playType = 4;
    }
    const currentScrollPosition = document.querySelector(".outlet-wrapper")
      ? document.querySelector(".outlet-wrapper").scrollTop
      : window.scrollY || document.documentElement.scrollTop;
    navigate(
      `/gamePlay/${companyCode}/${gameCode}/${companyOffset}/${currentScrollPosition}/${playType}`,
    );
  };

  useEffect(() => {
    if (location.state && location.state.gameType) {
      if (location.state.gameType === "live") {
        setCategory("live");
        setCategoryIndex(1);
      } else if (location.state.gameType === "app") {
        setCategory("app");
        setCategoryIndex(2);
      } else if (location.state.gameType === "fishing") {
        setCategory("fishing");
        setCategoryIndex(3);
      } else if (location.state.gameType === "sport") {
        setCategory("sport");
        setCategoryIndex(4);
      } else if (location.state.gameType === "lottery") {
        setCategory("lottery");
        setCategoryIndex(5);
      } else {
        setCategory("slot");
        setCategoryIndex(0);
      }
    } else {
      setCategory("slot");
    }
  }, []);

  useEffect(() => {
    sessionStorage.removeItem("lastSelectGame");
    fetchIPAddress().then((res) => {
      dispatch(
        actions.getHomePageUI({
          action: "mbhomepageV6",
          // platform: sessionStorage.getItem("platform") ?? "web",
          platform: "web",
          fcmnotificationid: "",
          ipaddress: res.ip,
        }),
      ).then((res) => {
        res = res.data;
        if (res.defaulttarget && !location.state?.gameType) {
          setCategory(res.defaulttarget);
          if (res.defaulttarget === "live") {
            setCategoryIndex(1);
          } else if (res.defaulttarget === "app") {
            setCategoryIndex(2);
          } else if (res.defaulttarget === "fishing") {
            setCategoryIndex(3);
          } else if (res.defaulttarget === "sport") {
            setCategoryIndex(4);
          } else if (res.defaulttarget === "lottery") {
            setCategoryIndex(5);
          } else {
            setCategoryIndex(0);
          }
        }
        dispatch(
          actions.getHomePageMemberData({
            action: "homepagebalance",
          }),
        );

        if (res.code === "0" && res.ibcacctexist === "true") {
          dispatch(
            actions.getIBCWidgetUrl({
              action: "ibcwidgetquicklink",
            }),
          );
        }
      });
    });

    return () => {
      dispatch(actions.resetIBCWidgetUrl());
    };
  }, []);

  const handleCategoryClick = (index, category) => {
    setCategoryIndex(index);
    setCategory(category);

    if (index === 6) {
      dispatch(
        actions.getHomePageHistory({
          action: "mbhomehistory",
        }),
      );
    }
  };

  const handleRefreshData = () => {
    setIsLoading(true);

    dispatch(
      actions.getHomePageMemberData({
        action: "homepagebalance",
      }),
    );

    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  const handlePullUpRefresh = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        if (categoryIndex === 6) {
          setCategoryIndex(6);
        } else if (categoryIndex === 0) {
          setCategoryIndex((prevIndex) => prevIndex + 1);
          setCategory("live");
        } else if (categoryIndex === 1) {
          setCategoryIndex((prevIndex) => prevIndex + 1);
          setCategory("app");
        } else if (categoryIndex === 3) {
          setCategoryIndex((prevIndex) => prevIndex + 1);
          setCategory("fishing");
        } else if (categoryIndex === 4) {
          setCategoryIndex((prevIndex) => prevIndex + 1);
          setCategory("sport");
        } else if (categoryIndex === 5) {
          setCategoryIndex((prevIndex) => prevIndex + 1);
          setCategory("lottery");
        }
        resolve();
      }, 100);
    });
  };

  const handleRefresh = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        if (categoryIndex === 0) {
          setCategoryIndex(0);
        } else if (categoryIndex === 1) {
          setCategoryIndex((prevIndex) => prevIndex - 1);
          setCategory("slot");
        } else if (categoryIndex === 2) {
          setCategoryIndex((prevIndex) => prevIndex - 1);
          setCategory("live");
        } else if (categoryIndex === 3) {
          setCategoryIndex((prevIndex) => prevIndex - 1);
          setCategory("app");
        } else if (categoryIndex === 4) {
          setCategoryIndex((prevIndex) => prevIndex - 1);
          setCategory("fishing");
        } else if (categoryIndex === 5) {
          setCategoryIndex((prevIndex) => prevIndex - 1);
          setCategory("sport");
        }
        resolve();
      }, 100);
    });
  };

  const handleItemClick = (companyCode, gametype) => {
    navigate(
      gametype === "lottery" ? `/${gametype}` : `/${gametype}/${companyCode}`,
    );
  };

  const createIBC = () => {
    dispatch(
      actions.createIBC({
        action: "ibcwidgetcreateacct",
      }),
    );
  };

  const handleRefreshIBC = () => {
    dispatch(
      actions.topupIBC({
        action: "ibcgamebalance",
      }),
    );
  };

  const topupIBC = () => {
    setSwalProps({
      show: true,
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: intl.formatMessage({
        id: "confirm",
      }),
      denyButtonText: intl.formatMessage({
        id: "cancel",
      }),
      icon: "info",
      title: intl.formatMessage({ id: "alert" }),
      text: intl.formatMessage({
        id: "confirmTopupIBC",
      }),
      onConfirm: () => {
        setSwalProps({});
        dispatch(
          actions.topupIBC({
            action: "ibcquicktopup",
          }),
        ).then(handleRefreshData);
      },
    });
  };

  const ManageBalance = ({ manageType }) => (
    <div
      onClick={() =>
        navigate(`/setting/${manageType}`, { state: { backTo: "/home" } })
      }
      className="d-flex flex-column align-items-center ms-2"
    >
      <div className="d-flex justify-content-center">
        <img
          src={toAbsoluteUrl(`/image/${manageType}.webp`)}
          style={{ width: "30px", height: "30px" }}
        />
      </div>
      <div className="text-font1 text-center text-light">
        {intl.formatMessage({ id: manageType })}
      </div>
    </div>
  );

  const checkIsGameTypeExist = (type) =>
    homeState.homePageUI?.gameTypeLists?.find(
      (gameType) => gameType.gametype === type,
    );

  const gamesList = checkIsGameTypeExist(category)?.recommendGameLists ?? [];

  return (
    <>
      {!homeState.homePageUI && (
        <>
          <div class="placeholder-glow">
            <div
              class="placeholder"
              style={{
                width: "100%",
                aspectRatio: "2017 / 528",
                height: "auto",
                background: "grey",
              }}
            />
          </div>
        </>
      )}
      {homeState.homePageUI?.freecreditexist === "true" && (
        <img
          src={`${process.env.PUBLIC_URL}/image/icon/angpau.webp`}
          className="position-absolute"
          style={{ width: "45px", bottom: "60px", right: "8px", zIndex: "3" }}
          onClick={() => navigate("/promotion")}
        />
      )}
      <SweetAlert2
        heightAuto={false}
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
        customClass="custom-swal"
      />
      <div className="d-flex flex-column align-items-stretch justify-content-center">
        {homeState.homePageUI?.ibcacctexist ? (
          homeState.homePageUI?.ibcacctexist === "false" ||
          homeState.homePageUI?.ibcvisible === "false" ? (
            <div className="position-relative">
              <img
                src={homeState.homePageUI?.topbannerimage}
                className={`w-100`}
                onClick={
                  homeState.homePageUI?.ibcvisible === "true"
                    ? () => createIBC()
                    : homeState.homePageUI?.apkdownloadlink !== ""
                      ? () =>
                          window.open(
                            `https://${homeState.homePageUI?.apkdownloadlink}?brand=${process.env.REACT_APP_IMAGE_PATH}`,
                            "_blank",
                          )
                      : undefined
                }
                style={
                  homeState.homePageUI?.ibcvisible === "true" ||
                  homeState.homePageUI?.apkdownloadlink !== ""
                    ? {
                        cursor: "pointer",
                      }
                    : undefined
                }
              />
            </div>
          ) : homeState.homePageUI?.ibcacctexist === "true" &&
            homeState.homePageUI?.ibcvisible === "true" ? (
            homeState.ibcWidgetLink?.gameurl ? (
              <div className="position-relative">
                <div className="position-absolute top-0 start-0 p-1 d-flex align-items-center gap-1">
                  <div className="text-white px-1 text-font2">
                    IBC {intl.formatMessage({ id: "balance" })} :{" "}
                    {homeState.ibcWidgetLink?.ibcbalance}
                    <IoMdRefresh
                      color="white"
                      className="pb-1"
                      size={20}
                      onClick={handleRefreshIBC}
                    />
                  </div>
                  <div
                    className="px-4 rounded-pill fw-bold"
                    style={{
                      color: "#000",
                      background: "#ffa500",
                      cursor: "pointer",
                      fontSize: "13px",
                    }}
                    onClick={() => topupIBC()}
                  >
                    {intl.formatMessage({ id: "topupIBC" })}
                  </div>
                </div>
                <iframe
                  src={homeState.ibcWidgetLink?.gameurl}
                  style={{
                    height,
                    width: "100%",
                  }}
                />
              </div>
            ) : (
              <div onClick={topupIBC}>
                <img
                  className="w-100"
                  src={toAbsoluteUrl("image/sport_load.webp")}
                />
              </div>
            )
          ) : null
        ) : (
          <Skeleton className="w-100 h-100" />
        )}
        {/* {homeState.homePageUI?.topBannerLists ? (
          <Carousel indicators={false} controls={false} className="w-100">
            {homeState.homePageUI.topBannerLists.map((topBanner, index) => (
              <Carousel.Item className="w-100">
                <img
                  key={index}
                  src={topBanner.imagename}
                  className={`d-block w-100 ${index === 0 ? "active" : ""}`}
                />
              </Carousel.Item>
            ))}
          </Carousel>
        ) : (
          <Skeleton className="w-100 h-100" />
        )} */}
      </div>
      <div>
        <div
          className="border rounded p-2 mx-2"
          style={{ background: "#181818" }}
        >
          <div className="d-flex align-items-center border-bottom pb-2">
            <div
              className="rounded-circle d-flex align-items-center justify-content-center me-2"
              style={{
                width: "20px",
                height: "15px",
                backgroundColor: "rgb(245, 190, 9)",
              }}
            >
              <span className="text-font4 text-light fw-bold">!</span>
            </div>
            {homeState.homePageUI && homeState.homePageUI.anncouncement && (
              <marquee
                className="text-font3 text-light"
                behavior="scroll"
                direction="left"
              >
                {homeState.homePageUI.anncouncement}
              </marquee>
            )}
          </div>
          <div className="d-flex pe-1 align-items-center">
            <span className="text-font4 text-light pe-1">
              {intl.formatMessage({ id: "welcome" })}
            </span>
            <span className="text-font4" style={{ color: "rgb(245, 190, 9)" }}>
              {auth.username}
            </span>
            {!isLoading && (
              <span className="ms-1" onClick={handleRefreshData}>
                <IoMdRefresh color="white" size={15} />
              </span>
            )}
          </div>
          <div className="d-flex p-1 justify-content-between">
            <div className="d-flex align-items-center">
              <div className="d-flex justify-content-center me-3">
                <div className="position-relative">
                  <img
                    className="cursor-pointer"
                    src={toAbsoluteUrl("image/homeProfile.webp")}
                    style={{ width: "45px" }}
                    onClick={() => navigate("/dashboard")}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-center align-items-start">
                <div className="d-flex flex-column align-items-start">
                  <div className="text-font2 text-light">
                    {intl.formatMessage({ id: "currency" })}
                  </div>
                  <div className="text-font2 text-light">
                    {intl.formatMessage({ id: "wallet" })}
                  </div>
                  <div className="text-font2 text-light">
                    {intl.formatMessage({ id: "game" })}
                  </div>
                </div>
                <div className="d-flex flex-column align-items-start mx-2">
                  <div className="text-font2 text-light">:</div>
                  <div className="text-font2 text-light">:</div>
                  <div className="text-font2 text-light">:</div>
                </div>
                {homeState.homePageMemberData ? (
                  <div className="d-flex flex-column align-items-start">
                    <div className="text-font2 text-light">
                      {isLoading
                        ? "-"
                        : homeState.homePageMemberData.currencycode}
                    </div>
                    <div className="text-font2 text-light">
                      {isLoading
                        ? "-"
                        : homeState.homePageMemberData.es3balance}
                    </div>
                    <div className="text-font2 text-light">
                      {isLoading
                        ? "-"
                        : homeState.homePageMemberData.gamebalance}
                    </div>
                  </div>
                ) : (
                  <Skeleton className="w-100" height="600px" />
                )}
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <ManageBalance manageType="deposit" />
              <ManageBalance manageType="withdraw" />
              <ManageBalance manageType="transfer" />
            </div>
          </div>
        </div>
        <div
          className={`w-100 ${
            homeState.homePageUI?.menubuttonvthz === "vertical" ? "d-flex" : ""
          } pt-2 justify-content-between px-2`}
        >
          <div
            style={
              homeState.homePageUI?.menubuttonvthz === "vertical"
                ? { overflowX: "auto" }
                : { overflowY: "auto" }
            }
            className={
              homeState.homePageUI?.menubuttonvthz === "vertical"
                ? "col-2"
                : "col-12 d-flex gap-3 pb-2"
            }
          >
            {homeState.homePageUI?.historyexist === "true" && (
              <div
                className="mb-2"
                onClick={() => handleCategoryClick(6, "history")}
              >
                <img
                  src={
                    categoryIndex === 6
                      ? toAbsoluteUrl(`/image/history1.png`)
                      : toAbsoluteUrl(`/image/history.png`)
                  }
                  alt="Slot"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
            )}
            {checkIsGameTypeExist("slot") && (
              <div
                className="mb-2"
                onClick={() => handleCategoryClick(0, "slot")}
              >
                <img
                  src={
                    categoryIndex === 0
                      ? toAbsoluteUrl(`/image/slot1.webp`)
                      : toAbsoluteUrl(`/image/slot.webp`)
                  }
                  alt="Slot"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
            )}
            {checkIsGameTypeExist("live") && (
              <div
                className="mb-2"
                onClick={() => handleCategoryClick(1, "live")}
              >
                <img
                  src={
                    categoryIndex === 1
                      ? toAbsoluteUrl(`/image/live1.webp`)
                      : toAbsoluteUrl(`/image/live.webp`)
                  }
                  alt="Live Casino"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
            )}
            {checkIsGameTypeExist("app") && (
              <div
                className="mb-2"
                onClick={() => handleCategoryClick(2, "app")}
              >
                <img
                  src={
                    categoryIndex === 2
                      ? toAbsoluteUrl(`/image/app1.webp`)
                      : toAbsoluteUrl(`/image/app.webp`)
                  }
                  alt="App"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
            )}
            {checkIsGameTypeExist("fishing") && (
              <div
                className="mb-2"
                onClick={() => handleCategoryClick(3, "fishing")}
              >
                <img
                  src={
                    categoryIndex === 3
                      ? toAbsoluteUrl(`/image/fishing1.webp`)
                      : toAbsoluteUrl(`/image/fishing.webp`)
                  }
                  alt="Fishing"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
            )}
            {checkIsGameTypeExist("sport") && (
              <div
                className="mb-2"
                onClick={() => handleCategoryClick(4, "sport")}
              >
                <img
                  src={
                    categoryIndex === 4
                      ? toAbsoluteUrl(`/image/sport1.webp`)
                      : toAbsoluteUrl(`/image/sport.webp`)
                  }
                  alt="Sport"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
            )}
            {checkIsGameTypeExist("lottery") && (
              <div
                className="mb-2"
                onClick={() => handleCategoryClick(5, "lottery")}
              >
                <img
                  src={
                    categoryIndex === 5
                      ? toAbsoluteUrl(`/image/lottery1.webp`)
                      : toAbsoluteUrl(`/image/lottery.webp`)
                  }
                  alt="Lottery"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
            )}
          </div>

          <div
            className="flex-fill px-2"
            style={{
              overflowY: "auto",
              margin: "0 auto",
            }}
          >
            {/* <PullToRefresh
              onRefresh={handleRefresh}
              onPullUp={handlePullUpRefresh}
              threshold={100}
            > */}
            {category && gamesList.length > 0 && (
              <div
                className="mb-2"
                style={{ borderBottom: "1px solid #ffa500" }}
              >
                <div className="text-white mb-1 text-font2">
                  {intl.formatMessage({ id: "recommendGames" })}
                </div>
                <Marquee speed={1}>
                  {gamesList.map((recommendGameList, index) => (
                    <GameItem
                      key={`game-${index}`}
                      game={recommendGameList}
                      handlePlayGame={handlePlayGame}
                      style={{}}
                      wrapperClass="mx-2 col-3"
                    />
                  ))}
                </Marquee>
              </div>
            )}
            {category === "history" ? (
              <div
                className="d-flex cursor-pointer"
                style={{
                  flexWrap: "wrap",
                  gap: "2.5%",
                }}
              >
                {homeState.homePageHistoryList?.historyGameLists.map(
                  (historyGameLists, index) => (
                    <GameItem
                      key={index}
                      game={historyGameLists}
                      handlePlayGame={handlePlayGame}
                    />
                  ),
                )}
              </div>
            ) : (
              homeState.homePageUI?.gameTypeLists &&
              homeState.homePageUI.gameTypeLists
                .filter((gameType) => gameType.gametype === category)
                .map((filteredGameType, index) =>
                  filteredGameType?.displaypattern === "banner" ? (
                    <div
                      key={index}
                      className="d-flex flex-column align-items-center justify-content-center cursor-pointer"
                    >
                      {filteredGameType.companyGameLists &&
                        filteredGameType.companyGameLists.map(
                          (game, gameIndex) => (
                            <div key={gameIndex} className="w-100">
                              <Image
                                className="custom-image"
                                imageUrl={game.imageurl}
                                alt={game.companyname}
                                name={game.companyname}
                                onClick={() =>
                                  handleItemClick(
                                    game.companycode,
                                    game.gametype,
                                  )
                                }
                              />

                              <div style={{ height: "5px" }}></div>
                            </div>
                          ),
                        )}
                    </div>
                  ) : (
                    <div
                      className="d-flex cursor-pointer"
                      style={{
                        flexWrap: "wrap",
                        gap: "2.5%",
                      }}
                    >
                      {filteredGameType.companyGameLists.map(
                        (companyGame, index) => (
                          <div
                            key={index}
                            style={{ width: "31%" }}
                            className="mb-2"
                          >
                            <Image
                              key={index}
                              className="custom-image w-100"
                              imageUrl={companyGame.imageurl}
                              alt={companyGame.companyname}
                              name={companyGame.companyname}
                              onClick={() =>
                                handleItemClick(
                                  companyGame.companycode,
                                  companyGame.gametype,
                                )
                              }
                            />
                          </div>
                        ),
                      )}
                    </div>
                  ),
                )
            )}

            {/* </PullToRefresh> */}
          </div>
        </div>
        <div>
          <div className="px-2">
            {homeState.homePageUI?.webinvitelink && (
              <div
                className="mt-3 mb-3 d-flex align-items-end gap-2"
                style={{ marginTop: "10px" }}
              >
                <div>
                  <QRCode
                    value={homeState.homePageUI?.webinvitelink}
                    size={100}
                    bgColor="#1c1e23"
                    fgColor="#fff"
                  />
                </div>
                <div
                  className="text-warning fw-bold"
                  style={{ fontSize: "14px" }}
                >
                  {intl.formatMessage({ id: "inviteFriend" })}
                </div>
              </div>
            )}
          </div>
          <div className="d-flex flex-column p-2">
            {homeState.homePageUI?.webinvitelink && (
              <div
                className="d-flex align-items-center"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <div
                  className="text-white text-font2 pe-1"
                  style={{ whiteSpace: "nowrap" }}
                >
                  {intl.formatMessage({ id: "invitationLink" })} :
                </div>
                <marquee
                  behavior="scroll"
                  direction="right"
                  style={{ color: "white" }}
                >
                  <div className="pe-3 text-font2">
                    {homeState.homePageUI.webinvitelink}
                  </div>
                </marquee>
                <i
                  className="ms-2 fa fa-copy cursor-pointer"
                  style={{ color: "white" }}
                  onClick={() => {
                    if (sessionStorage.getItem("platform") === "mobile") {
                      console.log(
                        `clipboard: ${homeState.homePageUI.webinvitelink}`,
                      );
                      CopyToClipboard(
                        homeState.homePageUI.webinvitelink,
                        setSwalProps,
                        intl,
                      );
                    } else {
                      CopyToClipboard(
                        homeState.homePageUI.webinvitelink,
                        setSwalProps,
                        intl,
                      );
                    }
                  }}
                />
              </div>
            )}
            {homeState.homePageUI?.webinvitelink &&
              homeState.homePageUI?.telegraminvitelink && (
                <div
                  className="my-1"
                  style={{ border: "1px solid #2e323a" }}
                ></div>
              )}
            {homeState.homePageUI?.telegraminvitelink && (
              <div
                className="d-flex align-items-center"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <div
                  className="text-white text-font2 pe-1"
                  style={{ whiteSpace: "nowrap" }}
                >
                  {intl.formatMessage({ id: "telegram" })} :
                </div>
                <marquee
                  behavior="scroll"
                  direction="right"
                  style={{ color: "white" }}
                >
                  <div className="pe-3 text-font2">
                    {homeState.homePageUI.telegraminvitelink}
                  </div>
                </marquee>
                <i
                  className="ms-2 fa fa-copy cursor-pointer"
                  style={{ color: "white" }}
                  onClick={() => {
                    if (sessionStorage.getItem("platform") === "mobile") {
                      console.log(
                        `clipboard: ${homeState.homePageUI.telegraminvitelink}`,
                      );
                      CopyToClipboard(
                        homeState.homePageUI.telegraminvitelink,
                        setSwalProps,
                        intl,
                      );
                    } else {
                      CopyToClipboard(
                        homeState.homePageUI.telegraminvitelink,
                        setSwalProps,
                        intl,
                      );
                    }
                  }}
                />
              </div>
            )}
          </div>

          <Modal show={showModal} onHide={handleCloseModal} centered>
            <Modal.Header
              closeButton
              closeVariant="white"
              className="bg-dark border-warning border-bottom"
            >
              <Modal.Title
                className="text-warning fw-bold"
                style={{ fontSize: "16px" }}
              >
                {selectedInbox?.title}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-dark text-white">
              {selectedInbox?.imageurl && (
                <img
                  src={selectedInbox.imageurl}
                  alt={selectedInbox.title}
                  className="img-fluid rounded w-100 mb-3"
                />
              )}
              <div
                style={{
                  whiteSpace: "pre-wrap",
                  fontSize: "14px",
                  lineHeight: "1.5",
                }}
              >
                {selectedInbox?.content}
              </div>
            </Modal.Body>
          </Modal>

          <div>
            <div
              className="text-warning fw-bold mt-3 mb-2 px-2"
              style={{ fontSize: "14px" }}
            >
              {intl.formatMessage({ id: "message" })}
            </div>
            {homeState.homePageUI?.messageLists.map((inbox, idx) => (
              <div
                key={idx}
                className="bg-dark rounded m-2 p-2 shadow"
                onClick={() => handleInboxClick(inbox)}
                style={{ cursor: "pointer" }}
              >
                <div className="text-white mb-1" style={{ fontSize: "12px" }}>
                  {inbox.title}
                </div>
                {inbox.imageurl && (
                  <img
                    src={inbox.imageurl}
                    alt={inbox.title}
                    className="img-fluid rounded w-100"
                  />
                )}
              </div>
            ))}
          </div>
          {/* License Online Game */}
          <div className="bg-dark rounded m-2 p-2 shadow">
            <div className="text-warning fw-bold mb-2">
              {intl.formatMessage({ id: "licenseOnlineGame" })}
            </div>
            <div>
              <img
                src={`${process.env.PUBLIC_URL}/image/landing/footer/curacao.webp`}
                style={{ width: "100%" }}
              />
            </div>
          </div>

          {/* Game Provider Platform */}
          <div className="bg-dark rounded m-2 p-2 shadow">
            <div className="text-warning fw-bold mb-2">
              {intl.formatMessage({ id: "gameProviderPlatform" })}
            </div>
            <div>
              <div className="d-flex p-2 align-items-center text-muted">
                <div className="col-4 d-flex flex-column align-items-center justify-content-center">
                  <div className="mb-3" style={{ fontSize: "11px" }}>
                    {intl.formatMessage({ id: "gamingLicense" })}
                  </div>
                  <div>
                    <img
                      src={`${process.env.PUBLIC_URL}/image/landing/footer/gamecert1.webp`}
                      style={{ height: "50px" }}
                    />
                    <img
                      src={`${process.env.PUBLIC_URL}/image/landing/footer/gamecert2.webp`}
                      style={{ height: "50px" }}
                    />
                  </div>
                </div>
                <div style={{ fontSize: "10px" }}>
                  {intl.formatMessage(
                    { id: "landingFooter1" },
                    { X: process.env.REACT_APP_SHORT_NAME },
                  )}
                </div>
              </div>
              <div className="border-bottom"></div>
              <div className="d-flex p-2 align-items-center text-muted">
                <div className="col-4 d-flex flex-column align-items-center justify-content-center">
                  <div className="mb-3" style={{ fontSize: "11px" }}>
                    {intl.formatMessage({ id: "gamingLicense" })}
                  </div>
                  <img
                    src={`${process.env.PUBLIC_URL}/image/landing/footer/pagcor.webp`}
                    style={{ width: "80%" }}
                  />
                </div>
                <div style={{ fontSize: "10px" }}>
                  {intl.formatMessage({ id: "landingFooter2" })}
                </div>
              </div>
            </div>
          </div>

          {/* Payment Methods */}
          <div className="bg-dark rounded m-2 p-2 shadow">
            <div className="text-warning fw-bold mb-2">
              {intl.formatMessage({ id: "paymentMethod" })}
            </div>
            <div className="d-flex flex-wrap gap-2">
              {[...Array(13)].map((_, idx) => (
                <img
                  key={idx}
                  src={`${process.env.PUBLIC_URL}/image/landing/bankLogo/Image (${idx + 1}).webp`}
                  alt="Bank"
                  className="bg-white rounded p-1"
                  style={{ height: "25px" }}
                  onError={(e) => (e.target.style.display = "none")}
                />
              ))}
            </div>
          </div>

          {/* Browser */}
          <div className="bg-dark rounded m-2 p-2 shadow">
            <div className="text-warning fw-bold mb-2">
              {intl.formatMessage({ id: "browserCooperatives" })}
            </div>
            <div className="d-flex gap-2">
              {[...Array(5)].map((_, idx) => (
                <img
                  key={idx}
                  src={`${process.env.PUBLIC_URL}/image/landing/browser/${idx + 1}.webp`}
                  alt="Browser"
                  className="bg-white rounded p-1"
                  style={{ height: "25px" }}
                  onError={(e) => (e.target.style.display = "none")}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
